import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { NursePractitioner } from 'src/app/model/np-data';
import { NursePractitionerService } from 'src/app/service/nursepractitioner.service';

import { AssignnpModalComponent } from './assignnp-modal/assignnp-modal.component';
import { NpPageRequest } from 'src/app/model/nppage-request';

@Component({
  selector: 'app-assign-nurse-practitioner',
  templateUrl: './assign-nurse-practitioner.component.html',
  styleUrls: ['./assign-nurse-practitioner.component.scss']
})
export class AssignNursePractitionerComponent implements OnInit {
  selectedNP: NursePractitioner = new NursePractitioner();
  nursePractitioner: NursePractitioner[];
  dataSource: MatTableDataSource<NursePractitioner>;
  searchKey: string = null;

  nameFilter = new FormControl();
  isAssignButtonDisabled: boolean = true;
  isTargetButtonDisabled: boolean = true;
  selection = new SelectionModel<NursePractitioner>(true, []);

  isRadionButtonClicked: boolean = false;

  assignedNP: NursePractitioner[]

  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;
  length: number;
  pageSizeOptions: number[] = [15, 30, 45];
  npPageRequest = new NpPageRequest();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

 /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. 'clientName', 'projectName', */
 displayedColumns = ['selection','nursePractitionerId', 'firstName', 'lastName', 'phoneNumber', 'serviceAddress1', 'serviceAddress2', 'state', 'city', 'zip', 'assignedClientNames', 'assignedProjectNames'];
 constructor(
   private nursePractitionerService: NursePractitionerService,
   public dialog: MatDialog,
   private _localStorage: LocalStorageService,
   private router: Router) {
 }

 ngOnInit() {
  this._localStorage.store('PageEvent', undefined);
  this.getNursepractitioner();
 }

 getNursepractitioner(event?: PageEvent, clearPagination?: boolean) {
  if(clearPagination){
    this._localStorage.store('PageEvent', undefined);
  }
   if (event != undefined) {
    this._localStorage.store('PageEvent', event);
     this.npPageRequest.pageNum = event.pageIndex;
     this.npPageRequest.pageSize = event.pageSize;
   }else if (event === undefined || event === null) {
     this.npPageRequest.pageNum = 0;
     this.npPageRequest.pageSize = 15;
   }
   this.npPageRequest.sortBy = "firstName";
     this.npPageRequest.sortDir = "ASC";
   if(this.searchKey!= undefined && this.searchKey != null){
     this.npPageRequest.searchValue = this.searchKey.toLowerCase();
   }else{
     this.npPageRequest.searchValue = '';
   }
   this.nursePractitionerService.getNursePractitioner(this.npPageRequest)
     .subscribe(result => {
       if (!result) {
         return;
       }
       console.log(result);
       this.nursePractitioner = result.nursePractitioners;
       this.dataSource = new MatTableDataSource(result.nursePractitioners);
       this.dataSource.sort = this.sort;
 
       if (event != undefined) {
         this.pageIndex = event.pageIndex;
         this.pageSize = event.pageSize;
         this.length = result.totalCount;
       }
       if (event === undefined || event === null) {
         this.pageIndex = 0;
         this.pageSize = 15;
         this.length = result.totalCount;
       }
       this.nameFilter.valueChanges.subscribe((nameFilterValue) => {
         this.dataSource.data = this.filterOptions(nameFilterValue);
       });
     }, error => console.log(error));
     return event;
 }

 openAssignDialog(): void {
   const dialogRef = this.dialog.open(AssignnpModalComponent, {
    panelClass: 'assign-sch-model',
     data:
       this.selectedNP
   });

   dialogRef.afterClosed().subscribe(result => {
     console.log("result " + result);
     this.getNursepractitioner(this._localStorage.retrieve('PageEvent'));
     this.isAssignButtonDisabled = true;
   });
 }

 reset() {
   this.isAssignButtonDisabled = true;
   this.isTargetButtonDisabled = true;
   this.isRadionButtonClicked = false;
   this.getNursepractitioner();
   this.selection.clear();
 }

 isAllSelected() {
   const numSelected = this.selection.selected.length;
   const numRows = this.dataSource.data.length;
   return numSelected === numRows;
 }

 toggle(row) {
   console.log(row.firstName + "<>" + this.selection.selected.includes(row))
   if (this.selection.selected.includes(row)) {
     this.selection.deselect(row)
   } else {
     this.selection.select(row)
   }
   if (this.selection.selected.length > 0) {
     this.isAssignButtonDisabled = false;
     this.isTargetButtonDisabled = false;
   } else {
     this.isAssignButtonDisabled = true;
     this.isTargetButtonDisabled = true;
   }
 }

 masterToggle() {
   this.isAllSelected() ?
     this.selection.clear() :
     this.dataSource.data.forEach(row => { this.selection.select(row) });
   if (this.selection.selected.length > 0) {
     this.isAssignButtonDisabled = false;
     this.isTargetButtonDisabled = false;
   } else {
     this.isAssignButtonDisabled = true;
     this.isTargetButtonDisabled = true;
   }
 }

 filterOptions(nameValue: string): NursePractitioner[] {
   if (!nameValue) {
     return this.nursePractitioner;
   }
   const filtered = this.nursePractitioner.filter((element) => {
     return (nameValue ? element.firstName.toLowerCase().includes
       (nameValue.toLowerCase()) : false) || (nameValue ? element.lastName.toLowerCase().includes
         (nameValue.toLowerCase()) : false)
   });
   return filtered;
 }

 customFilterPredicate() {
   const myFilterPredicate = function (data: NursePractitioner, filter: string): boolean {
     let searchString = JSON.parse(filter);
     return data.firstName.toString().trim().toLowerCase().indexOf(searchString.name.toLowerCase()) !== -1 &&
       data.lastName.toString().trim().toLowerCase().indexOf(searchString.name.toLowerCase()) !== -1;
   }
   return myFilterPredicate;
 }

 radiobuttonClick(event, nursePractitioner: NursePractitioner): void {
   this.isRadionButtonClicked = true;
   this.isAssignButtonDisabled = false;
   if (nursePractitioner.isAssigned) {
     this.isTargetButtonDisabled = false;
   } else {
     this.isTargetButtonDisabled = true;
   }
   this.selectedNP = nursePractitioner;
 }

 onSearchClear() {
  this.searchKey = "";
  this.getNursepractitioner();
}
}